import { render, staticRenderFns } from "./BackupLinkExternal.vue?vue&type=template&id=1f22d254&scoped=true&"
import script from "./BackupLinkExternal.vue?vue&type=script&lang=js&"
export * from "./BackupLinkExternal.vue?vue&type=script&lang=js&"
import style0 from "./BackupLinkExternal.vue?vue&type=style&index=0&id=1f22d254&prod&lang=scss&scoped=true&"
import style1 from "./BackupLinkExternal.vue?vue&type=style&index=1&id=1f22d254&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22d254",
  null
  
)

export default component.exports